import Projects from '../components/Projects'
import Title from '../components/Title'
import Skills from '../components/Skills'
import Footer from '../components/Footer'

export default function MainPage () {
  return (
    <section className='bg-gradient-to-r from-white to-blue-500 p-[15px]'>
      <Title />
      <Skills />
      <Projects />
      <Footer />
    </section>
  )
}
